// tslint:disable:max-line-length

import React from 'react';

export const StatusUnlocked = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <path d="M8,0C5.8,0,4,1.8,4,4v1h2V4c0-1.2,0.8-2,2-2s2,0.8,2,2v4H2v8h12V8h-2V4C12,1.8,10.2,0,8,0z" />
    </svg>
  );
};
